import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "expired",
  class: "d-flex align-center flex-column mt-10"
}
const _hoisted_2 = { id: "buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SessionExpired',
  setup(__props) {

const reloadApp = () => {
  const queryString = window.location.search;

  const url = queryString.split("=")[1] + "=" + queryString.split("=")[2] + "=" + queryString.split("=")[3];
  window.location.href = url;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_icon, {
      color: "error",
      size: "large",
      class: "text-h1 pb-4"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-alert-circle-outline", -1)
      ]))]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-h3 pb-6" }, "Your session has expired", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h5 pt-4 pb-4" }, "Please reload the application.", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn_primary, {
        size: "small",
        block: "",
        onClick: reloadApp
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Reload Application", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})